import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Warenkorb } from '../../../store/models/warenkorb';
import { Kunde } from '../../../store/models/kunde';
import { Artikel } from '../../../store/models/artikel';

@Injectable({
    providedIn: 'root'
})
export class WarenkorbsService {

    constructor(
        private restService: RestService,
    ) { }

    getById(id: number) : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<void, Warenkorb.IWarenkorbDto>({
            method: 'GET',
            url: '/api/app/warenkorb/' + id
        });
    }

    getForCustomer() : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<number, Warenkorb.IWarenkorbDto>({
            method: 'GET',
            url: '/api/app/warenkorb/for-customer'
        });
    }

    addPosition(input: Warenkorb.IAddPositionDto) : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<Warenkorb.IAddPositionDto, Warenkorb.IWarenkorbDto>({
            method: 'POST',
            url: '/api/app/warenkorb/position/',
            body: input
        });
    }

    addPositions(input: Warenkorb.IWarenkorbArtikelsDto) : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<Warenkorb.IWarenkorbArtikelsDto, Warenkorb.IWarenkorbDto>({
            method: 'POST',
            url: '/api/app/warenkorb/positions/',
            body: input
        });
    }

    deletePosition(id: number) : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<void, Warenkorb.IWarenkorbDto> ({
            method: 'DELETE',
            url: `/api/app/warenkorb/${id}/position`
        });
    }

    updateWarenkorb(id:number, input: Warenkorb.IUpdateWarenkorbDto) : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<Warenkorb.IUpdateWarenkorbDto, Warenkorb.IWarenkorbDto>({
            method: 'PUT',
            url: `/api/app/warenkorb/${id}`,
            body: input
        });
    }

    deleteWarenkorb(id: number) : Observable<boolean> {
        return this.restService.request<void, boolean> ({
            method: 'DELETE',
            url: `/api/app/warenkorb/${id}/warenkorb`
        });
    }

    getRechnungsadresse() : Observable<Kunde.IKundeDto> {
        return this.restService.request<void, Kunde.IKundeDto>({
            method: 'GET',
            url: '/api/app/warenkorb/rechnungsadresse'
        });
    }
    
    getRechnungsadresse2() : Observable<string> {
        return this.restService.request<void, string>({
            method: 'GET',
            url: '/api/app/warenkorb/rechnungsadresse2'
        });
    }

    getPaymentterm() : Observable<Warenkorb.IWarenkorbDto> {
        return this.restService.request<void, Warenkorb.IWarenkorbDto>({
            method: 'GET',
            url: '/api/app/warenkorb/paymentterm'
        });
    }

    getAddresslist(kennungen: string, getaltadresses:boolean=false) {
        return this.restService.request<void, Kunde.IKundeDto[]>({
            method: 'GET',
            url: `/api/app/warenkorb/addresslist?kennungen=${kennungen}&getaltadresses=${getaltadresses}`
        });
    }
    
    makeOrder(input: Warenkorb.IWarenkorbDto) : Observable<boolean> {
        
        return this.restService.request<Warenkorb.IWarenkorbDto, boolean>({
            method: 'POST',
            url: `/api/app/warenkorb/${input.id}/Make-Order`,
            body: input
        });
    }

    makeRequest(input: Warenkorb.IWarenkorbDto) : Observable<boolean> {
        
        return this.restService.request<Warenkorb.IWarenkorbDto, boolean>({
            method: 'POST',
            url: `/api/app/warenkorb/${input.id}/Make-Request`,
            body: input
        });
    }

    //Eric
    getStaffelpreis(kennung_artikel: number) {
        return this.restService.request<void, string>({
            method: 'GET',
            url: `/api/app/warenkorb/staffelpreis?kennung_artikel=${kennung_artikel}`
        });
    }

}
